"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { useOverviewLayout } from "@/contexts/overview-layout-context";
import type { PatientOverviewProps } from "@/lib/overview-section-registry";
import { cx } from "@/lib/tailwind-utils";
import type { ChargeTableItem } from "@/types/charge";
import type { FormTable, PatientSubmissionsTable } from "@/types/forms/form";
import type { PatientChart } from "@/types/patient";
import type { QuickNoteSummary } from "@/types/quick-note";
import IdentificationSection from "./identification-section";
import OverviewTabEditView from "./views/edit-view";
import OverviewTabReadView from "./views/read-view";
interface OverviewTabProps {
  patient: PatientChart;
  charges?: ChargeTableItem[];
  forms?: FormTable[];
  formSubmissions?: PatientSubmissionsTable;
  quickNotes?: QuickNoteSummary[];
}
export default function OverviewTab(t0) {
  const $ = _c(17);
  const {
    patient,
    charges,
    forms,
    formSubmissions,
    quickNotes
  } = t0;
  const {
    state
  } = useOverviewLayout();
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const updateWidth = () => {
        if (containerRef.current) {
          setContainerWidth(containerRef.current.offsetWidth);
        }
      };
      updateWidth();
      const resizeObserver = new ResizeObserver(updateWidth);
      if (containerRef.current) {
        resizeObserver.observe(containerRef.current);
      }
      return () => {
        resizeObserver.disconnect();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!patient) {
    return null;
  }
  const shouldUseTwoColumns = containerWidth >= 750;
  let t3;
  if ($[2] !== charges || $[3] !== formSubmissions || $[4] !== forms || $[5] !== patient || $[6] !== quickNotes || $[7] !== shouldUseTwoColumns) {
    t3 = {
      patient,
      shouldUseTwoColumns,
      charges,
      forms,
      formSubmissions,
      quickNotes
    };
    $[2] = charges;
    $[3] = formSubmissions;
    $[4] = forms;
    $[5] = patient;
    $[6] = quickNotes;
    $[7] = shouldUseTwoColumns;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const renderProps = t3;
  let t4;
  if ($[9] !== patient) {
    t4 = <IdentificationSection patient={patient} />;
    $[9] = patient;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== renderProps || $[12] !== state.mode) {
    t5 = state.mode === "edit" ? <OverviewTabEditView {...renderProps} /> : <OverviewTabReadView {...renderProps} />;
    $[11] = renderProps;
    $[12] = state.mode;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div ref={containerRef} className="space-y-12">{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
export const OverviewLabel = t0 => {
  const $ = _c(7);
  const {
    isSelected
  } = t0;
  const {
    actions
  } = useOverviewLayout();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span>Overview</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = actions.enterEditMode;
  const t3 = isSelected ? "opacity-100" : "hidden";
  let t4;
  if ($[1] !== t3) {
    t4 = cx("text-caption flex items-center gap-0.5 font-normal transition-opacity duration-150", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FiEdit />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== actions.enterEditMode || $[5] !== t4) {
    t6 = <div className="flex items-center justify-between gap-1.5 w-full group">{t1}<span role="button" onClick={t2} className={t4}>{t5}Customize layout</span></div>;
    $[4] = actions.enterEditMode;
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};